module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "l3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status Type")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.statusList,
      "label": "Status Type",
      "item-value": "id",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncReloadStatusList
    },
    model: {
      value: (_vm.statusType),
      callback: function($$v) {
        _vm.statusType = $$v
      },
      expression: "statusType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 linkTable",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.objUserStatus,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.excluded),
            callback: function($$v) {
              _vm.$set(props.item, "excluded", $$v)
            },
            expression: "props.item.excluded"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-4 pr-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateUserStatus()
      }
    }
  }, [_vm._v("Save")])], 1)])])], 1)], 1)
},staticRenderFns: []}